import React, { KeyboardEventHandler, useRef, useState } from 'react';
import AttenderItem from '@/components/Record/SubjectContent/AttenderItem';
import AttenderInput from '@/components/Record/SubjectContent/AttenderInput';
import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import { useTranslation } from 'react-i18next';
import useClickOutside from '@/components/Record/SubjectContent/@hooks/useClickOutside';

const registerName = 'searchFields.externalAttender';

const ExternalAttender = () => {
  const { t } = useTranslation();
  const [isFocus, setIsFocus] = useState(false);
  const { getValues, setValue, watch } = useFormContext<RecordFilter>();

  const externalAttender = watch('external');
  const ref = useRef<HTMLDivElement>(null);

  const handleDelete = (title: string) => {
    const current = getValues('external');
    const updated = current.filter((item) => item !== title);
    setValue('external', updated);
  };

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (event.nativeEvent.isComposing) return;

    const inputValue = getValues(registerName);
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (getValues('external').some((res) => res === inputValue)) {
          return;
        }
        setValue('external', [...getValues('external'), inputValue]);
        setValue(registerName, '');
        event.preventDefault();
    }
  };

  useClickOutside(ref, () => {
    setIsFocus(false);
    setValue('searchFields.externalAttender', '');
  });

  return (
    <div ref={ref}>
      <AttenderInput
        isFocus={isFocus}
        placeholder={t('외부 참석자를 엔터로 구분해 입력해 주세요')}
        registerName={registerName}
        leftChildren={externalAttender.map((title, idx) => (
          <AttenderItem
            key={`key-${title}-${idx}`}
            title={title}
            handleDelete={handleDelete}
          />
        ))}
        handleKeyDown={handleKeyDown}
        onFocus={() => setIsFocus(true)}
      />
    </div>
  );
};

export default ExternalAttender;
